// Route Code Edited 5/6/26
/**
 * Route Element Attribute Handler — v2 (onclick-safe)
 *
 * Use this version if your config removes the onclick attribute from
 * [data-route-cloned-button]. 
 * 
 * Watches for configured elements in the DOM and enforces class and attribute
 * changes via MutationObserver. Re-enforces on any mutation to prevent
 * third-party apps from overwriting Route's element state.
 *
 * Each entry in ELEMENT_CONFIGS targets a selector independently.
 *
 */

(function routeElementAttributeHandler() {
  const ELEMENT_CONFIGS = [
    {
      selector: '[data-route-widget] [data-route-cloned-button]',
      classesToRemove: [],
      classesToAdd: [],
      attrs: {
        'onclick': null,
        'id': null,
        'data-original-display': null,
      },
    },
  ];

  function hasUnwantedState(el, config) {
    return (
      config.classesToRemove.some(c => el.classList.contains(c)) ||
      config.classesToAdd.some(c => !el.classList.contains(c)) ||
      Object.entries(config.attrs).some(([a, v]) =>
        v === null
          ? el.hasAttribute(a)
          : el.getAttribute(a) !== v
      )
    );
  }

  function applyChanges(el, config, observer, savedOnclick) {
    observer.disconnect();

    config.classesToRemove.forEach(c => el.classList.remove(c));
    config.classesToAdd.forEach(c => el.classList.add(c));
    Object.entries(config.attrs).forEach(([a, v]) => {
      if (v === null) {
        el.removeAttribute(a);
      } else {
        el.setAttribute(a, v);
      }
    });

    if (config.attrs['onclick'] === null && savedOnclick) {
      el.onclick = savedOnclick;
    }

    observer.observe(el, {
      attributes: true,
      attributeFilter: ['class', ...Object.keys(config.attrs)],
    });
  }

  function watchElement(el, config) {
    if (el._routeHandlerWatched) return;
    el._routeHandlerWatched = true;

    const savedOnclick = el.onclick;

    const observer = new MutationObserver((mutations) => {
      if (hasUnwantedState(el, config)) {
        applyChanges(el, config, observer, savedOnclick);
        // document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    });

    applyChanges(el, config, observer, savedOnclick);
  }

  const domObserver = new MutationObserver(() => {
    ELEMENT_CONFIGS.forEach(config => {
      document.querySelectorAll(config.selector).forEach(el => {
        watchElement(el, config);
      });
    });
  });

  domObserver.observe(document.body, { childList: true, subtree: true });

  ELEMENT_CONFIGS.forEach(config => {
    document.querySelectorAll(config.selector).forEach(el => {
      watchElement(el, config);
    });
  });

  window.addEventListener('pagehide', () => domObserver.disconnect());
})();